const translations = {
    drones: 'Drones',
    dronesAreRequired: 'At least one drone is required'
};

export default translations;
